import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { CalculatorsService } from '../calculators.service';
import {
  FormControl,
  FormGroup
} from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonCalculatorComponent } from '../common-calculator/common-calculator.component';
import { DropdownComponent } from '@iv/shared/components/dropdown/dropdown.component';
import {PaymentWindowService} from '../../payment-window.service';
import { filter } from 'rxjs/operators';
import { replaceExclude, validateForContainNumber } from '../helpers/calc.helpers';
import { IStockExpiryTime } from '../models/stock-expiry-time';
import { getHttpParams } from "@iv/shared/utils";
import { Instrument } from "@iv/model/instrument";

@Component({
  selector: 'iv-live-options-calculator',
  templateUrl: './options-calculator.component.html',
  styleUrls: ['./options-calculator.component.scss']
})
// TODO: Привести в порядок названия методов и свойств
export class OptionsCalculatorComponent implements OnInit, OnDestroy {

  @Input() instrument;
  @Input() instruments = [];
  @Input() mode = 'eod';
  @Input() stockId: string;

  @Output() closeButtonClicked = new EventEmitter<any>();
  @Output() returnRegionEvent = new EventEmitter<any>();
  @Output() showMessageEvent = new EventEmitter<any>();
  @Output() openDropdownEvent = new EventEmitter<any>();
  @Output() onInstrumentChange: EventEmitter<Instrument> = new EventEmitter<Instrument>();

  @ViewChild(CommonCalculatorComponent, {static: false}) commonCalculator !: CommonCalculatorComponent;
  @ViewChildren(DropdownComponent) dropdown: QueryList<DropdownComponent>;

  stockType = 'A';
  number = 1;
  calculatorForm: FormGroup;
  type = 'call';
  optionPrice;
  optionPriceChanged: Subject<string> = new Subject<string>();
  inputChanged: Subject<string> = new Subject<string>();
  calculatedIVCall = 0;
  calculatedIVPut = 0;
  seriesCall = '';
  seriesPut = '';
  style;
  styleName = ' ';
  styles: any = {
    'A': {
      name: 'American',
      value: 'A'
    },
    'E': {
      name: 'European',
      value: 'E'
    }
  };
  dividendFrequencyName = ' ';
  dividendFrequencies: any = {
    '1': {
      name: 'Annually',
      value: '1'
    },
    '2': {
      name: 'Semiannually',
      value: '2'
    },
    '4': {
      name: 'Quarterly',
      value: '4'
    },
    '12': {
      name: 'Monthly',
      value: '12'
    }
  };
  parameters: any = {};
  price: any;
  priceStrike: any;
  expDate: any;
  longExpDate: any;
  Vola: any;
  rate: any;
  lastDividendDate: any;
  lastDividendAmount: any;
  dividendFrequency;
  _yield;
  daysToExp: number;
  result: any = {};
  regionId: any = 1;
  expirations = [];
  hours: number;
  minutes: number;
  error = null;
  expTime: any;
  optPriceIsEmpty = false;
  ivIsNull = true;
  symbNotFound = false;
  loading = false;
  dateMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
  isLoading = false;
  private isEod = false;
  private _customDate = {
    expDate: 'Custom date',
    daysToExp: '',
    hours: '',
    minutes: ''
  };

  constructor(
    private _calculatorsService: CalculatorsService,
    private spinner: NgxSpinnerService,
    private readonly paymentWindowService: PaymentWindowService
  ) { }

  ngOnInit() {
    this.paymentWindowService.showPaymentWindow();
    this.isLoading = false;
    this.calculatorForm = new FormGroup({
      firstName: new FormControl(),
      price: new FormControl(),
      priceStrike: new FormControl(),
      expDate: new FormControl(),
      Vola: new FormControl(),
      rate: new FormControl(),
      lastDividendDate: new FormControl(),
      lastDividendAmount: new FormControl(),
      dividendFrequency: new FormControl()
    });
    this.optionPriceChanged
      .debounceTime(2000)
      .distinctUntilChanged()
      .subscribe((optionPrice: string) => {
        this.optionPrice = optionPrice;
        this.optPriceIsEmpty = false;
        this.calculateIV();
      });
    this.inputChanged
      .debounceTime(2000)
      .distinctUntilChanged()
      .pipe(filter(() => this.expDate?.expDate))
      .subscribe(() => this.calculateOption());
  }

  public ngOnDestroy() {
    this.commonCalculator.ngOnDestroy();
  }

  onlyNumbersPaste($event) {
    const input = $event.srcElement;
    const inputValue = parseFloat(input.value);

    if (input.dataset.id === 'vola' && input.previousElementSibling.textContent.startsWith('Interest Rate')) {
      input.value = input.value.replace(/\-{2,}|[^\d\.]\./g, '-').replace(/\.\-/g, '.').replace(/^[^\d\-]|[^\d\-.]|\b-/g, '').replace(/^0{2,}/g, '0').replace(/^\-0{2,}/g, '-0');
      if ((input.value.match(/\./g) !== null) && (input.value.match(/\./g).length > 1)) {
        input.value = input.value.substr(0, input.value.lastIndexOf('.'));
      }
    } else if (input.dataset.id === 'daysToExp' || input.dataset.id === 'hoursToExp' || input.dataset.id === 'minToExp') {
      input.value = input.value.replace(/\-{2,}/g, '-').replace(/[^0-9\-]|\b-/g, '');
    } else {
      input.value = input.value.replace(/[^0-9\.]|^\./g, '').replace(/^0{2,}/g, '0');
      if ((input.value.match(/\./g) !== null) && (input.value.match(/\./g).length > 1)) {
        input.value = input.value.substr(0, input.value.lastIndexOf('.'));
      }
    }

    function removeTooltip() {
      if (input.nextElementSibling !== null) {
        input.nextElementSibling.remove();
        input.style.borderColor = '';
      }
    }

    if ((inputValue < 0 || inputValue > 1000000)
      && input.dataset.id !== 'yield'
      && !input.previousElementSibling.textContent.startsWith('Interest Rate')
      && !input.parentNode.classList.contains('time-values')
    ) {
      removeTooltip();
      input.style.borderColor = 'red';
      this.inputTooltip(input, 'Please enter a value between 0 and 1 000 000');
    } else if (!input.parentNode.classList.contains('time-values')) {
      removeTooltip();
    }
  }

  dateValidate($event) {
    const dateInput = $event.srcElement;
    const dateArr = dateInput.value.split('-');
    const month = Number(dateArr[1]);
    const day = Number(dateArr[2]);

    function removeTooltip() {
      if (dateInput.nextElementSibling !== null) {
        dateInput.nextElementSibling.remove();
        dateInput.style.borderColor = '';
      }
    }

    if ((month && month > 12) || (day && day > 31)) {
      removeTooltip();
      dateInput.style.borderColor = 'red';
      this.inputTooltip(dateInput, 'Please enter the date in the format yyyy-mm-dd');
    } else {
      removeTooltip();
    }
  }

  inputTooltip(elem, tooltipText) {
    const param = elem.parentNode;
    param.style.position = 'relative';
    const tooltip = document.createElement('div');
    const tooltipFigure = document.createElement('div');
    const tooltipContent = document.createElement('div');

    tooltip.classList.add('calc-input-tooltip');

    tooltip.style.cssText = `
      position: absolute;
      left: 100%;
      display: flex;
      z-index: 9999;
      height: 23px;
      margin-top: 2px;
    `;

    tooltipFigure.style.cssText = `
      border-right: 7px solid rgba(245, 97, 112, 0.8);
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      height: 10px;
      margin-top: 5px;
    `;

    tooltipContent.style.cssText = `
      background: rgba(245, 97, 112, 0.8);
      font-weight: 400;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      line-height: 23px;
      padding: 0 10px;
      white-space: nowrap;
    `;

    tooltipContent.innerText = tooltipText;

    tooltip.appendChild(tooltipFigure);
    tooltip.appendChild(tooltipContent);
    param.appendChild(tooltip);
  }

  keyDown(event) {
    const charCode = (event.query) ? event.query : event.keyCode;
    if (charCode === 8 || charCode === 127) {
      this.clearResult();
    }
  }

  keyDownSearch() {
    const inputFields = document.querySelectorAll('input.param-value');
    const inputTooltips = document.querySelectorAll('.calc-input-tooltip');
    if (inputTooltips) {
      inputTooltips.forEach((elem) => {
        elem.remove();
      });
    }
    inputFields.forEach((elem: HTMLElement) => {
      elem.style.borderColor = '';
    });

  }

  clearStock() {
    this.commonCalculator.stockName = null;
    this.commonCalculator._stockName = null;
    this.commonCalculator.stockSearchCriteria = null;
  }

  clearResult() {
    for (const i of Object.keys(this.result)) {
      this.result[i] = null;
    }
  }

  clearAll() {
    this.clearStock();
    this.clearResult();
    this.keyDownSearch();
  }

  calculateIV() {
    if (this.optionPrice === null) {
      this.optPriceIsEmpty = true;
    } else {
      this.optPriceIsEmpty = false;
      this.hideSpinner();
      this.spinner.show('optionCalculatorSpinner');
      this.isLoading = true;
      this._calculatorsService
        .getIV(
          this.optionPrice,
          this.style,
          this.price,
          this.priceStrike,
          this.expDate.expDate,
          this.daysToExp,
          this.expDate.hours,
          this.expDate.minutes,
          this.Vola,
          this.rate,
          this.lastDividendDate,
          this.lastDividendAmount,
          this.dividendFrequency,
          this._yield,
          this.stockId,
          this._isEod(),
          this.stockType,
          'call'
        ).subscribe((response) => {
            this.hideSpinner();
            if (response.status === 200) {
              const result = response.body;
              this.calculatedIVCall = result.vola;
            }
            this.ivIsNull = false;
          });

        this._calculatorsService
        .getIV(
          this.optionPrice,
          this.style,
          this.price,
          this.priceStrike,
          this.expDate.expDate,
          this.daysToExp,
          this.expDate.hours,
          this.expDate.minutes,
          this.Vola,
          this.rate,
          this.lastDividendDate,
          this.lastDividendAmount,
          this.dividendFrequency,
          this._yield,
          this.stockId,
          this._isEod(),
          this.stockType,
          'put'
        ).subscribe((response) => {
            this.hideSpinner();
            if (response.status === 200) {
              const result = response.body;
              this.calculatedIVPut = result.vola;
            }
            this.ivIsNull = false;
          });
    }
  }

  changeOptPrice(text: string) {
    this.optionPriceChanged.next(text);
  }

  calculateOption() {
    this.number = 2;
    this.calculate();
  }

  showSpinner() {
    this.isLoading = true;
    this.spinner.show('optionCalculatorSpinner');
  }

  calculate() {
    if (!this.stockId) return;

    this.hideSpinner();
    this.spinner.show('optionCalculatorSpinner');
    this.isLoading = true;

    const expiryTime: IStockExpiryTime = this.expDate.expDate !== 'Custom date' ? {
      daysToExp: this.expDate.daysToExp,
      hoursToExp: this.expDate.hours,
      minutesToExp: this.expDate.minutes
    } : {
      daysToExp: this.daysToExp,
      hoursToExp: this.hours,
      minutesToExp: this.minutes
    };

    this.getOptionCalculatorResult(expiryTime);
  }

  getOptionCalculatorResult(expiryTime: IStockExpiryTime) {
    this._calculatorsService.getOptionCalculatorResult(getHttpParams(
      {
        style: this.style,
        price: this.price ? replaceExclude(this.price) : undefined,
        priceStrike: this.priceStrike ? replaceExclude(this.priceStrike) : undefined,
        expDate: this.expDate.expDate && this.expDate.expDate !== 'Custom date' && this.expDate.expDate !== ' ' ?
          `${this.expDate.expDate} ${String(expiryTime.hoursToExp).padStart(2, '0')}:${String(expiryTime.minutesToExp).padStart(2, '0')}` : undefined,
        daysToExp: expiryTime.daysToExp ? replaceExclude(String(expiryTime.daysToExp)) : undefined,
        hoursToExp: expiryTime.hoursToExp ? replaceExclude(String(expiryTime.hoursToExp)) : undefined,
        minutesToExp: expiryTime.minutesToExp ? replaceExclude(String(expiryTime.minutesToExp)) : undefined,
        vola: this.Vola ? replaceExclude(this.Vola) : undefined,
        rate: this.rate != null ? validateForContainNumber(this.rate) : undefined,
        lastDividentDate: this.lastDividendDate ? replaceExclude(this.lastDividendDate) : undefined,
        lastDividentAmount: this.lastDividendAmount ? replaceExclude(this.lastDividendAmount) : undefined,
        dividentFrequency: this.dividendFrequency,
        yield: this._yield ? replaceExclude(this._yield) : undefined,
        stockId: this.stockId,
        dividendType: this.stockType === 'I' || this.stockType === 'X' ? 'Yield' :
          (this.stockType === 'S' || this.stockType === 'F' ? 'Regular' : 'NoDividend'),
        number: this.number ? String(this.number) : undefined,
        isEod: String(this._isEod() ? this._isEod() : false)
      }
    ))
      .subscribe(calculationResult => {
        const { seriesCall, seriesPut } = calculationResult;

        if (seriesCall) this.seriesCall = seriesCall;

        if (seriesPut) this.seriesPut = seriesPut;

        this.result = calculationResult;
        this.hideSpinner();
      },
      () => this.hideSpinner()
    );
  }

  onModeChanged($event: { isEod: boolean, instrument: string }) {
    this.stockId = $event.instrument;
    this.isEod = $event.isEod;
  }

  fillParametersAndLoadData($event: { isEod: boolean, id: string }) {
    this.symbNotFound = false;
    if ($event.id) {
      this.stockId = $event.id;
      this.isEod = $event.isEod;
      this.isLoading = true;
      this.hideSpinner();
      this.spinner.show('optionCalculatorSpinner');
      this._getExpirations().then(() => {
        this._getParameters($event).then(data => {
          this._fillParameters(data);
          if (this.expirations.length === 0 && !this.symbNotFound) {
            console.log(`fillParametersAndLoadData expirations`, this.expirations)
            this.showMessageEvent.emit({message: 'Data not found', type: 'error'});
          } else {
            if (!this.symbNotFound) {
              this.calculate();
            }
          }
        }, () => {
          console.warn('smth went wrong');
        });
      });
    }
  }

  hideSpinner() {
    if (this.isLoading) {
      this.isLoading = false;
      this.spinner.hide('optionCalculatorSpinner');
    }
  }

  symbolNotFound() {
    this.showMessageEvent.emit({message: 'Symbol not found', type: 'error'});
  }

  onGoButtonClick($event: any) {
    this.fillParametersAndLoadData($event);
    this.number = 1;
  }

  getArrayFromObject(someObj) {
    return Object.values(someObj);
  }

  getHoursMinutesToExp(): Observable<HttpResponse<any>> {
    return this._calculatorsService.getHoursMinutesToExp(
      this.longExpDate,
      this.isEod,
      this.stockId
    );
  }

  selectExpiration($event: any) {
    this.clearResult();
    this.expDate = {
      expTime: $event.longExpDate.substring(11, 16),
      expDate: $event.expDate.substring(0, 10),
      daysToExp: $event.daysToExp,
      hours: $event.hours,
      minutes: $event.minutes,
      longExpDate: $event.longExpDate
    };

    this.daysToExp = $event.daysToExp;
    this.hours = $event.hours;
    this.minutes = $event.minutes;
    this.longExpDate = $event.longExpDate;
    this.expTime = $event.longExpDate.substring(11, 16);
    this.getHoursMinutesToExp().subscribe(response => {
      this.setExpiration(response);
    });
    this.getOpionIV().subscribe(response => {
      this.Vola = (response * 100).toFixed(2);
      this.getRate().subscribe(response => {
        this.rate = response.toFixed(4);
      });
    });
    this.calculateOption();
  }

  setExpiration(response: HttpResponse<any>): void {
    if (response.status === 200) {
      const result = response.body;
      this.hours = result.hours;
      this.minutes = result.minutes;

      this.expDate = {
        expTime: result.expDate.substring(11, 16),
        expDate: result.expDate.substring(0, 10),
        daysToExp: result.daysToExp,
        longExpDate: result.expDate,
        hours: result.hours,
        minutes: result.minutes
      };
    } else if (response.status === 206) {
      this.result = response.body;
    } else {
      this.result = {};
    }
  }

  getOpionIV(): Observable<number> {
    return this._calculatorsService.getOptionIV(
      this.stockId,
      this.expDate.expDate,
      this.priceStrike
    );
  }

  getRate(): Observable<number> {
    return this._calculatorsService.getRate(
      this.stockId,
      this.expDate.daysToExp
    );
  }

  selectFrequency($event: any) {
    this.dividendFrequency = $event.value;
    this.clearResult();
    this.calculateOption();
  }

  selectStyle($event: any) {
    this.style = $event.value;
    this.clearResult();
    this.calculateOption();
  }

  onExpValueInput($event, valueName: string) {
    this.onlyNumbersPaste($event);
    this[valueName] = $event.srcElement.value;
    this._selectCustomExpiration();
  }

  onScroll($event) {
    $event.scrollIntoView();
  }

  getHours() {
    if (this.expDate) {
      return this.expTime;
    }
    return '';
  }

  changeInstrument(instrument: Instrument): void {
    this.stockType = instrument.stockType;
    this.onInstrumentChange.emit(instrument);
  }

  getTypeDropDown() {
    if (this.expirations.length > 6) {
      return 'expirations';
    }
    return '';
  }

  showMessage() {
    this.showMessageEvent.emit({message: 'Option symbol was copied successfully', type: 'success'});
  }

  switchMode() {
    this.commonCalculator.switchMode();
  }

  returnRegion($event) {
    const region = $event.region;
    this.returnRegionEvent.emit({region: region});
  }

  openDropdown(index: number) {
    this.dropdown.toArray().forEach((item, i) => {
      if (i !== index) {
        item.close();
      }
    });
    this.openDropdownEvent.emit();
  }

  closeOptionsDropdown() {
    this.dropdown.toArray().forEach((item) => {
      item.close();
    });
  }

  inputHandler(text: string): void {
    this.inputChanged.next(text);
  }

  private _getParameters($event: { isEod: boolean, id: string }) {
    this.hideSpinner();
    this.spinner.show('optionCalculatorSpinner');
    this.isLoading = true;
    return new Promise((resolve, reject) => {
      this._calculatorsService.getOptionCalculatorParameters($event.id, $event.isEod).subscribe(response => {
        this.hideSpinner();
        if (response.status === 200) {
          const result = response.body;
          resolve(result);
        } else if (response.status === 400) {
          reject();
        } else {
          reject();
        }
      });
    });
  }

  private _fillParameters(parameters) {
    if (parameters) {
      this.parameters = parameters;
      this.price = +parameters.price.toFixed(2);
      this.priceStrike = parameters.priceStrike;
      if (this.priceStrike !== 0.0) {
        this.priceStrike = +this.priceStrike.toFixed(2);
      }
      this.expDate = {
        expTime: parameters.expDate.substring(11, 16),
        daysToExp: parameters.daysToExp,
        longExpDate: parameters.expDate,
        expDate: parameters.expDate.substring(0, 10),
        hours: parameters.hours,
        minutes: parameters.minutes
      };
      this.expTime = parameters.expDate.substring(11, 16),
        this.daysToExp = parameters.daysToExp;
      this.hours = parameters.hours;
      this.minutes = parameters.minutes;
      this.longExpDate = parameters.expDate;
      this.Vola = (parameters.Vola * 100).toFixed(2);
      this.rate = parameters.rate;
      if (this.rate !== 0.0) {
        this.rate = this.rate.toFixed(4);
      }
      this.lastDividendDate = parameters.lastDividendDate.substring(0, 10);
      this.lastDividendAmount = parameters.lastDividendAmount;
      if (this.lastDividendAmount !== 0.0 && this.lastDividendAmount !== null) {
        this.lastDividendAmount = this.lastDividendAmount.toFixed(2);
      }
      this.dividendFrequency = parameters.dividendFrequency;
      if (this.dividendFrequency === 0) {
        this.dividendFrequencyName = ' ';
      }
      if (this.dividendFrequency === 1) {
        this.dividendFrequencyName = 'Annually';
      }
      if (this.dividendFrequency === 2) {
        this.dividendFrequencyName = 'Semiannually';
      }
      if (this.dividendFrequency === 4) {
        this.dividendFrequencyName = 'Quarterly';
      }
      if (this.dividendFrequency === 12) {
        this.dividendFrequencyName = 'Monthly';
      }
      if (this.regionId) {
        this.regionId = parameters.regionId;
      }
      this.stockType = parameters.stockType;
      this.style = parameters.style;
      if (this.style === 'A') {
        this.styleName = 'American';
      }
      if (this.style === 'E') {
        this.styleName = 'European';
      }
      this._yield = (parameters.Yield * 100).toFixed(2);
    }
    if (
      this.price === 0 &&
      (this.style === null || this.style === ' ') &&
      this.priceStrike === 0 &&
      this.daysToExp === 0 &&
      this.hours === 0 &&
      this.minutes === 0 &&
      this.Vola === 0.00 &&
      this.rate === 0 &&
      this.lastDividendAmount === null &&
      this.dividendFrequency === null &&
      (this._yield === 0.00 || this._yield === null) &&
      (this.regionId === null || this.regionId === 0)) {

      this.symbNotFound = true;
      this.symbolNotFound();
    }
  }

  private _getExpirations() {
    return new Promise((resolve, reject) => {
      this._calculatorsService.getExpirations(this.stockId, this._isEod()).then(response => {
        this.expirations = response.map(expiration => {
          return {
            expTime: expiration.expDate.substring(11, 16),
            daysToExp: expiration.daysToExp,
            longExpDate: expiration.expDate,
            expDate: expiration.expDate.substring(0, 10),
            hours: expiration.hours,
            minutes: expiration.minutes
          };
        });
        resolve(response);
      });
    });
  }

  private _selectCustomExpiration() {
    this.expDate = this._customDate;
    this.clearResult();
    this.calculateOption();
  }

  private _isEod() {
    return this.isEod;
  }
}
